/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcPaymentsV1IncomingAchState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_PAYMENTS_V1_INCOMING_ACH_STATE_ENTITY_NAME = 'ixc.payments.v1.IncomingAch';
export const ixcPaymentsV1IncomingAchStateEntity = new schema.Entity<IxcPaymentsV1IncomingAchState>(IXC_PAYMENTS_V1_INCOMING_ACH_STATE_ENTITY_NAME, {}, { idAttribute: 'achId' });

